export default __webpack_public_path__ + "images/T3.caed206.png";